export const browserConfigs = {
  "POLICY": 0, // 0: blacklist  1:whitelist
  "WEBRTC_UNSUPPORT_BLACKLIST": [/.*chrome\/([1-6]\d|7[0-1])\..*MiuiBrowser.*/ig, /.*chrome\/([1-6]\d|70)\..*HeyTapBrowser.*/ig, /.*chrome\/([1-5]\d|6[0-2])\..*VivoBrowser.*/ig],
  "WEBRTC_UNSUPPORT_WHITELIST": []
}